import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';
import _ from 'lodash';
import {interval} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  display: number = 1;
  connectedTime: any;
  unknownTimerVal: any;
  unKnowTimerThreadId :any;

  /**
   * This service is created as to create Timer thread which continues to be alive till
   * call  ends .
   * and to start and stop the timer when call/chat stops.
   * @param
   * @author :Pooja Gupta
   */

  constructor(private rootScope: RootScopeService) {}
  /**Below Map is basically user for multiple chat case where 2 live chats will be active i.e 2 CA will be enabled */
  timerMap: any = {};

  timer: any;

  updateTimerMapWithCustomerSessionId(customerSessionId) {
 /* istanbul ignore next */
    let timerVal = 1;
    if(this.unknownTimerVal &&  this.unknownTimerVal != NaN ){
      timerVal = this.unknownTimerVal  ;
    
    }
    

    this.timerMap[customerSessionId] = { timerValue:  timerVal};
    this.createTimerThread(timerVal, customerSessionId);
  }

  startTimerAtCallLand(connectedTime){
    this.unKnowTimerThreadId = 0;
    this.unknownTimerVal = 0;
    let cloned = this.timerMap[Constants.UNKNOWN]?.timerThreadId
    if(cloned)
      clearInterval(cloned);

      
    delete this.timerMap?.[Constants.UNKNOWN];
    let cloneObj = _.cloneDeep(this.timerMap)
    console.log("startTimerAtCallLand called")
    this.connectedTime = connectedTime;
    this.timerMap = cloneObj;
    // this.timerMap[Constants.UNKNOWN] = { 'timerValue': 1};
    console.log("this.timerMap at call lands",this.timerMap)
    // this.createTimerThread(1, Constants.UNKNOWN);
  }

  startTimerAtChatLand(customerSessionId,connectedTime ){
    this.timerMap[customerSessionId] = connectedTime;
  }

  /**
   * 
   * @param timerVal Below method starts the timer from when  last customer account timer's value
   * @param newCustomerSessionId 
   */
  continueTimerForReplace(timerVal, newCustomerSessionId) {
    
    this.timerMap[newCustomerSessionId] = { timerValue: timerVal };
    this.createTimerThread(timerVal, newCustomerSessionId);
  }

  stopTimer(customerSessionId) {
    let cloneObj = _.cloneDeep(this.timerMap[Constants.UNKNOWN]);
    clearInterval(this.timerMap[customerSessionId]?.timerThreadId);
    clearInterval(this.unKnowTimerThreadId);
    delete this.timerMap[Constants.UNKNOWN];
    
    
  }

  createTimerThread(minute, customerSessionId) {
    let seconds: number = 0;
    if (minute != 1) {  /**Case of Replace account ***/
      let arr = minute.split(':');
      let min :number = arr[0] ;
      seconds = (min * 60) + parseInt(arr[1]);
    }

    console.log("timerMap",this.timerMap)
    let textSec: any = '0';
    const prefix = '0' ;

    let that = this;
    /* istanbul ignore next */
    let timer = interval(1000).subscribe(()=>{
      seconds++;
      if (seconds < 10) {
        textSec = '0' + seconds;
      } 
      else if (seconds >= 60) {
        textSec = seconds % 60;
        if(textSec < 10)
          textSec = '0' + textSec;
      }
      else textSec = seconds;

      let timerVal = '';
      if((Math.floor(seconds/60)) < 10 ){ /** When min is 0 to 9 , as per req "0" to be appended in the beginning */
        timerVal = `${prefix}${Math.floor(seconds / 60)}:${textSec}`
      }
      else{
        timerVal = `${Math.floor(seconds / 60)}:${textSec}`
      }

      if(customerSessionId == Constants.UNKNOWN){
        this.unknownTimerVal = timerVal;
        this.unKnowTimerThreadId = timer;
      }
      else if(customerSessionId &&  that.timerMap[customerSessionId]){
        that.timerMap[customerSessionId]['timerValue'] = timerVal
        that.timerMap[customerSessionId]["timerThreadId"] = timer;
      }
        
    }) 
  }
}
